/* Klaviyo subscribe — no redirect, inline status. Uses the public client API. */
(function () {
  'use strict';

  function bind(form) {
    if (!form || form.__bound) return;
    form.__bound = true;

    const companyId = form.dataset.companyId;
    const listId = form.dataset.listId;
    const emailEl = form.querySelector('input[type="email"]');
    const successMsg = form.querySelector('.klaviyo-form__msg--success');
    const errorMsg = form.querySelector('.klaviyo-form__msg--error');
    const submit = form.querySelector('button[type="submit"]');
    const labelEl = form.querySelector('.klaviyo-form__submit-label');

    function setMsg(kind) {
      [successMsg, errorMsg].forEach((m) => m && (m.hidden = true));
      if (kind === 'success' && successMsg) successMsg.hidden = false;
      if (kind === 'error' && errorMsg) errorMsg.hidden = false;
    }

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!emailEl || !emailEl.value || !emailEl.checkValidity()) {
        emailEl && emailEl.focus();
        setMsg('error');
        return;
      }
      if (!companyId || !listId) {
        // Misconfigured: keep the form visibly working but log for the operator
        console.warn('[Klaviyo] missing company/list id — set them in theme customizer.');
        setMsg('error');
        return;
      }

      submit && submit.setAttribute('disabled', 'disabled');
      const prevLabel = labelEl ? labelEl.textContent : '';
      if (labelEl) labelEl.textContent = (window.HYDRAW && window.HYDRAW.t && window.HYDRAW.t.submitting) || '...';

      try {
        // /client/subscriptions/ — public endpoint, consent is implicit by virtue
        // of POSTing to it. The profile resource at revision 2024-02-15 doesn't
        // accept a `subscriptions` field; later revisions reject the request the
        // other way around. 2024-02-15 is the stable revision for this payload.
        const res = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'revision': '2024-02-15'
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'HYDRAW website footer',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email: emailEl.value }
                  }
                }
              },
              relationships: { list: { data: { type: 'list', id: listId } } }
            }
          })
        });

        if (res.ok || res.status === 202) {
          setMsg('success');
          form.reset();
        } else {
          // Surface the exact Klaviyo error so the operator can see what's
          // wrong (bad list ID, domain not allow-listed, etc.).
          let body = '';
          try { body = await res.text(); } catch (e) { /* noop */ }
          console.error('[Klaviyo] subscribe failed', res.status, body);
          setMsg('error');
        }
      } catch (err) {
        console.error('[Klaviyo] network error', err);
        setMsg('error');
      } finally {
        submit && submit.removeAttribute('disabled');
        if (labelEl) labelEl.textContent = prevLabel;
      }
    });
  }

  document.querySelectorAll('[data-klaviyo-form]').forEach(bind);
  // Re-bind when the customizer re-renders sections
  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('[data-klaviyo-form]').forEach(bind);
  });
})();
